import React, { useRef } from 'react';
import styles from './AdminMobileCateRegister.module.css';
import { textFormat } from "InitialData/regExp";
import Container from 'layouts/container/Container';
import { mainBgColor, mainPadd, mainPadd2, pageCommonGap1, pageCommonPadd2, pageH1FontSize, registerFontSize, registerGap2, registerHeight } from 'routes/adminMobile/constraints/AdminConst';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import P from 'components/P';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import InputText from 'components/inputs/signUp/InputText';
import { validateInputs } from 'shared/utils/Utils';
import { toast } from "react-toastify";

const AdminMobileCateRegister = () => {
    const inputs = useRef([]);
    const {moveToBack} = useCustomAdminMobileMove();

    let data = {
        storeId: "root",
        categoryName: "",
    };

    // 카테고리 등록 버튼 클릭 함수
    const onClick = () => {
        // 초기화 된 데이터
        

        validateInputs(inputs.current).then((result) => {
            if(result.isValid) {
                data.categoryName = inputs.current[0].getValue();

                // validate 이후 데이터 확인
                
            }else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    return (
        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' />
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>카테고리 등록</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex backgroundColor={mainBgColor} padding={mainPadd2} gap={"1.5rem"}>
                        <FlexChild>
                            <AdminMobileContentBox flexStart>
                                <VerticalFlex gap={registerGap2}>
                                    {/* 반복 구간 */}
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap="0.5rem">
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>카테고리</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"카테고리 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    {/* 반복 구간 */}
                                </VerticalFlex>
                            </AdminMobileContentBox>
                        </FlexChild>
                        <FlexChild height="initial">
                            <div className={styles.regiBtn} onClick={onClick}>
                                <span>카테고리 등록</span>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileCateRegister;